import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import * as QueryString from "query-string"


const rootElement = document.getElementById('root');
const params = QueryString.parse(window.location.search);

let pc = params.ctcpc || rootElement.getAttribute('pc');
let filt = params.ctcfilter || rootElement.getAttribute('filter');
let tags = params.ctctags || rootElement.getAttribute('tags');
let parts = params.ctcparts || rootElement.getAttribute('parts');
let binding = params.ctcbinding || rootElement.getAttribute('binding');
let data = params.ctcdata || rootElement.getAttribute('data');
let cols = params.ctccols || rootElement.getAttribute('cols');
let pn = params.ctcpn || rootElement.getAttribute('pn');
let nocache = params.ctcnocache || rootElement.getAttribute('nocache');

let thing = ReactDOM.render(
    <App pc={pc} filt={filt} tags={tags} parts={parts} binding={binding}
        data={data} cols={cols} pn={pn} nocache={nocache}/>,
  rootElement);

registerServiceWorker();

//#region Custom

var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
var eventer = window[eventMethod];
var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

// Listen for a message from the iframe.
eventer(messageEvent, function (e) {
    var e_data = e.data + '';
    if (e_data == 'reset') {
        thing.incKey('');
    }
}, false);

window.ctcpcreset = function ()
{
    thing.incKey('');
}

let preheight = 0;
function sendHeight() {
    if (window.parent.postMessage) {

        // get the container element of the page
        let height = document.getElementById('root').offsetHeight;

        // if the height has changed, send a message
        if (preheight != height) {
            window.parent.postMessage('H;' + height, '*');
        }

        preheight = height;
    }
}

if (params.mode == 'embed' || params.mode == 'pldata' || params.mode == 'imageplus' ||
    params.mode == 'image' || params.mode == 'imagecomponents') {
    setInterval(function () { sendHeight(); }, 100);
}

//#endregion